import { FC, PropsWithChildren } from 'react';

import { ItineraryView, LegView } from '@mopla/data-models';
import { LbodtflexContextProvider } from '@mopla/i18';
import { useTranslation } from '@mopla/i18';
import { checkTimeMightChange } from '@mopla/utils';

import { FlexColumn, IconMessage, LegDetailsV2, TildaIcon } from '../../../../';

import { ContentPaper, LegsWrapper } from './styled';

export interface IRouteLegsDetailsMapProps extends PropsWithChildren {
	itinerary: ItineraryView;
	isTicket?: boolean;
	cancellationFee?: number;
	isCancelled?: boolean;
}

export const RouteLegsDetailsMap: FC<IRouteLegsDetailsMapProps> = ({
	itinerary,
	isTicket,
	cancellationFee,
	isCancelled,
	children,
}) => {
	const { t } = useTranslation('common');
	const timeMightChange = checkTimeMightChange(itinerary);

	return (
		<ContentPaper>
			<FlexColumn gap={24}>
				{timeMightChange && (
					<IconMessage
						icon={<TildaIcon sx={{ fontSize: '12px' }} />}
						message={t('text.attentionTimeMayChange')}
						variant="caption"
					/>
				)}
				<LegsWrapper gap={16}>
					{itinerary?.legs &&
						itinerary.legs.map((leg: LegView, index, legs) => (
							<LbodtflexContextProvider
								key={leg.legId}
								value={leg.lbodtflexLabel}
							>
								<LegDetailsV2
									leg={leg}
									isBookedItinerary={isTicket}
									isFirstLeg={index === 0}
									isLastLeg={index === legs.length - 1}
									cancellationFee={cancellationFee}
									disabled={isCancelled}
								/>
							</LbodtflexContextProvider>
						))}
				</LegsWrapper>
				{children}
			</FlexColumn>
		</ContentPaper>
	);
};
